import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  columnTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    fontFamily: theme.palette.typography.fontFamily,
    marginBottom: "1.25rem",
  },
  columnDescription: {
    fontSize: "0.875rem",
  },
}));

const MDCTextWithDescription = ({ label, description, children }) => {
  const { columnTitle, columnDescription } = useStyles();

  return (
    <>
      <div>
        {label && <label className={columnTitle}>{label}</label>}
        {description && <p className={columnDescription}>{description}</p>}
      </div>
      {children}
    </>
  );
};

export default MDCTextWithDescription;
